/* eslint-disable no-console */
import {SORT} from '../incase-domain/common/sort.enum';
import {IPresentationTheme} from '../incase-domain/presentationTheme';
import {httpDelete, httpGet, httpPost} from './http.service';

export const fetchPresentationThemeListService = (sortBy?: Record<string, SORT>): Promise<IPresentationTheme[]> => {
    let params = {};

    if (sortBy) params = {...params, ...sortBy};
    return httpGet(`editor/presentationTheme/`, {params});
};

export const createPresentationTheme = (presentationTheme: IPresentationTheme): Promise<IPresentationTheme> => {
    return httpPost(`editor/presentationTheme/create`, {theme: presentationTheme}).catch((error) => {
        console.log(error);

        if (error.response && error.response.data && error.response.status === 403) {
            throw new Error(error.response.data.message);
        } else {
            return {errors: error.response.data};
        }
    });
};

export const updatePresentationThemeService = (presentationThemeId: string, presentationTheme: IPresentationTheme): Promise<boolean> => {
    return httpPost(`editor/presentationTheme/update/${presentationThemeId}`, presentationTheme).catch((error) => {
        console.log(error);

        return {errors: error.response.data};
    });
};

export const deletePresentationTheme = (themeId: string): Promise<boolean> => {
    return httpDelete(`editor/presentationTheme/${themeId}`, {}).catch((error) => {
        console.log(error);

        return {errors: error.response.data};
    });
};

export const fetchPresentationThemeService = (themeId: string): Promise<IPresentationTheme> => {
    return httpGet(`editor/presentationTheme/${themeId}`).catch((error) => {
        console.log(error);

        return {errors: error.response.data};
    });
};
